import { api_base } from '../api';
import { dialog } from '../../scripts/confirm';
import { toast } from '../../scripts/toast';
import { router } from '../../routes/routes';
import { convertToUrl } from '../../scripts/convert_name';
import Store from '../store';


export const Selections = {
  getByAlias (selection, cbSuccess, cbError) {
    $.ajax({
      url: api_base + '/selections_by_alias/' + selection,
      method: 'GET',
      headers: {
        Accept: 'application/json'
      },

      success (res) {
        cbSuccess(res)
      },

      error (err) {
        cbError(err)
      }
    })
  }
}


// WEBPACK FOOTER //
// ./src/store/api/selections.js